import router from '../routes/router';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['fetchCollection', 'fetchDocument']),
    toRoute(route) {
      return router.push(route);
    },
    downloadFile(link) {
      window.location.href = link;
    },
    goToTicketList() {
      window.location.href =
        'https://bloco.co.uk/events/leicester-caribbean-carnival-2026';
    },
    scrollToSection(id, extra = 0) {
      const section = document.getElementById(id);
      const position = this.getOffset(section);
      window.scrollTo(position.left, position.top - extra);
    },
    hideZoomModal() {
      this.$refs['full-img-modal'].hide();
    },
    showZoomModal() {
      this.$refs['map-zoom-container'].$refs['full-img-modal'].show();
    },
    getOffset(el) {
      const rect = el.getBoundingClientRect();
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY,
      };
    },
    login(email, password) {
      if (!email || !password) {
        console.log('Please provide login and password');
        return true;
      }
      this.$store.dispatch('login', { email, password });
    },
    logout() {
      this.$store.dispatch('logout');
    },
    headerSwitch() {
      const nav = document.getElementById('nav');
      if (!nav) {
        return false;
      }
      if (window.scrollY > 80) {
        nav.classList.add('sweet-nav', 'shadow-sm');
      } else {
        document
          .getElementById('nav')
          .classList.remove('sweet-nav', 'shadow-sm');
      }
    },
    setTagColor(index) {
      const colors = [
        'text-yellow',
        'text-lilac',
        'text-blue-50',
        'text-green',
      ];
      const colorChoiceIndex = index % colors.length;
      return colors[colorChoiceIndex];
    },
    showLoader(elem) {
      let div = document.createElement('div');
      div.innerHTML =
        '<span aria-hidden="true" class="ml-2 spinner-border spinner-border-sm" style="width: 17px; height: 17px;"></span>';
      elem.append(div);
    },
    hideLoader(elem) {
      elem.removeChild(elem.childNodes[1]);
    },
  },
  computed: {
    ...mapState({
      saving: (state) => state.general.saving,
      processing: (state) => state.general.processing,
      pageLoading: (state) => state.general.pageLoadingState,
    }),
    ...mapGetters({
      profileLoaded: 'profileLoaded',
      profile: 'getProfile',
    }),
  },
  metaInfo() {
    return {
      meta: this.$route.meta.tags || [],
    };
  },
};
